<form>
  <section class="main-section">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" *ngIf="user.role == 'ROLE_ADMIN'"><a routerLink="/admin/adminDashboard/">Home</a>
        </li>
        <li class="breadcrumb-item" *ngIf="user.role == 'CUSTOMER_CARE'"><a
          routerLink="/admin/customercareOrders/">Home</a></li>
        <li class="breadcrumb-item active" aria-current="page">Reports</li>
      </ol>
    </nav>
    <div class="row">
      <div class="col">
        <div class="inner-box p-4">
          <h2>Reports</h2>

          <div class="row mt-4">

            <div class="col-md-6" *ngIf="user.role == 'ROLE_ADMIN'">
              <div class="report-box">
                <div class="row">
                  <div class="col-md-auto p-0">
                    <div class="icon-box" style="background-color: #96D1FE;">
                      <svg xmlns="http://www.w3.org/2000/svg" width="28" viewBox="0 0 16 16">
                        <path id="Icon_material-shopping-cart" data-name="Icon material-shopping-cart"
                              d="M6.3,15.8a1.6,1.6,0,1,0,1.6,1.6A1.6,1.6,0,0,0,6.3,15.8ZM1.5,3V4.6H3.1l2.88,6.072L4.9,12.632a1.547,1.547,0,0,0-.2.768A1.6,1.6,0,0,0,6.3,15h9.6V13.4H6.636a.2.2,0,0,1-.2-.2l.024-.1.72-1.3h5.96a1.592,1.592,0,0,0,1.4-.824L17.4,5.784a.782.782,0,0,0,.1-.384.8.8,0,0,0-.8-.8H4.868L4.116,3ZM14.3,15.8a1.6,1.6,0,1,0,1.6,1.6A1.6,1.6,0,0,0,14.3,15.8Z"
                              transform="translate(-1.5 -3)" fill="#fff"></path>
                      </svg>
                      Orders
                    </div>
                  </div>
                  <div class="col-md">
                    <div class="row">
                      <div class="col-md-6">
                        <button class="btn btn-cancel-prime btn-block" routerLink="/admin/adminReportDetails"
                                [queryParams]="{type: 'Order Detail'}">Order Detail
                        </button>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class="col-md-6" *ngIf="user.role == 'ROLE_ADMIN'">
              <div class="report-box">
                <div class="row">
                  <div class="col-md-auto p-0">
                    <div class="icon-box" style="background-color: #79E198;">
                      <svg xmlns="http://www.w3.org/2000/svg" height="28" viewBox="0 0 20.99 16.792">
                        <path id="Icon_awesome-shipping-fast" data-name="Icon awesome-shipping-fast"
                              d="M20.465,11.545h-.525V8a1.574,1.574,0,0,0-.462-1.112L16.2,3.611a1.574,1.574,0,0,0-1.112-.462H13.644V1.574A1.575,1.575,0,0,0,12.069,0h-8.4A1.575,1.575,0,0,0,2.1,1.574V3.149H.262A.263.263,0,0,0,0,3.411v.525A.263.263,0,0,0,.262,4.2H9.183a.263.263,0,0,1,.262.262v.525a.263.263,0,0,1-.262.262H1.312a.263.263,0,0,0-.262.262v.525a.263.263,0,0,0,.262.262H8.134a.263.263,0,0,1,.262.262v.525a.263.263,0,0,1-.262.262H.262A.263.263,0,0,0,0,7.609v.525A.263.263,0,0,0,.262,8.4H7.084a.263.263,0,0,1,.262.262v.525a.263.263,0,0,1-.262.262H2.1v4.2a3.149,3.149,0,1,0,6.3,0h4.2a3.149,3.149,0,1,0,6.3,0h1.574a.526.526,0,0,0,.525-.525v-1.05A.526.526,0,0,0,20.465,11.545ZM5.248,15.218a1.574,1.574,0,1,1,1.574-1.574A1.575,1.575,0,0,1,5.248,15.218Zm10.5,0a1.574,1.574,0,1,1,1.574-1.574A1.575,1.575,0,0,1,15.743,15.218ZM18.366,8.4H13.644V4.723H15.09L18.366,8Z"
                              fill="#fff"></path>
                      </svg>
                      Shipments
                    </div>
                  </div>
                  <div class="col-md">
                    <div class="row">
                      <div class="col-md-6">
                        <button disabled class="btn btn-cancel-prime btn-block" routerLink="/admin/adminReportDetails"
                                [queryParams]="{type: 'Shipments'}">Shipments
                        </button>
                      </div>
                      <div class="col-md-6">
                        <button disabled class="btn btn-cancel-prime btn-block" routerLink="/admin/adminReportDetails"
                                [queryParams]="{type: 'Shipment Cost'}">Shipments Costs
                        </button>
                      </div>
                      <div class="col-md-6">
                        <button disabled class="btn btn-cancel-prime btn-block" routerLink="/admin/adminReportDetails"
                                [queryParams]="{type: 'Shipped products'}" style="text-overflow: ellipsis;">Shipments
                          Products
                        </button>
                      </div>
                      <div class="col-md-6">
                        <button class="btn btn-cancel-prime btn-block" routerLink="/admin/shipmentExceptionReport"
                                style="text-overflow: ellipsis;">Shipments
                          Exception
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class="col-md-6"
                 *ngIf="user.role == 'ROLE_ADMIN' || user.role == 'SALES_MKTG'">
              <div class="report-box">
                <div class="row">
                  <div class="col-md-auto p-0">
                    <div class="icon-box" style="background-color: #F6B554;">
                      <svg xmlns="http://www.w3.org/2000/svg" height="28" viewBox="0 0 15.733 15.733">
                        <path id="Icon_awesome-box" data-name="Icon awesome-box"
                              d="M15.656,5.673,14.1,1.008A1.471,1.471,0,0,0,12.7,0H8.358V5.9h7.335A1.4,1.4,0,0,0,15.656,5.673ZM7.375,0H3.03a1.471,1.471,0,0,0-1.4,1.008L.077,5.673A1.4,1.4,0,0,0,.04,5.9H7.375ZM0,6.883v7.375a1.475,1.475,0,0,0,1.475,1.475H14.258a1.475,1.475,0,0,0,1.475-1.475V6.883Z"
                              fill="#fff"></path>
                      </svg>
                      Products
                    </div>
                  </div>
                  <div class="col-md">
                    <div class="row">
                      <div class="col-md-6">
                        <button class="btn btn-cancel-prime btn-block" routerLink="/admin/adminReportDetails"
                                [queryParams]="{type: 'Demand by SKU'}">Demand by SKU
                        </button>
                      </div>
                      <div class="col-md-6">
                        <button class="btn btn-cancel-prime btn-block" routerLink="/admin/adminReportDetails"
                                [queryParams]="{type: 'Product Sales'}">Product Sales
                        </button>
                      </div>
                      <div class="col-md-6">
                        <button class="btn btn-cancel-prime btn-block" routerLink="/admin/adminReportDetails"
                                [queryParams]="{type: 'Returned Products list'}">Returned Products list
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class="col-md-6" *ngIf="user.role == 'ROLE_ADMIN' || user.role == 'SALES_MKTG'">
              <div class="report-box">
                <div class="row">
                  <div class="col-md-auto p-0">
                    <div class="icon-box" style="background-color: #FE9696;">
                      <svg xmlns="http://www.w3.org/2000/svg" height="28" viewBox="0 0 23.754 28.505">
                        <path id="Icon_map-accounting" data-name="Icon map-accounting"
                              d="M24.979.72h-19A2.382,2.382,0,0,0,3.6,3.1V26.85a2.382,2.382,0,0,0,2.375,2.375h19a2.382,2.382,0,0,0,2.375-2.375V3.1A2.382,2.382,0,0,0,24.979.72ZM10.726,24.474a1.191,1.191,0,0,1-1.188,1.188H7.163a1.191,1.191,0,0,1-1.188-1.188v-.594a1.191,1.191,0,0,1,1.188-1.188H9.539a1.191,1.191,0,0,1,1.188,1.188Zm0-4.751a1.191,1.191,0,0,1-1.188,1.188H7.163a1.191,1.191,0,0,1-1.188-1.188V19.13a1.191,1.191,0,0,1,1.188-1.188H9.539a1.191,1.191,0,0,1,1.188,1.188Zm0-4.751A1.191,1.191,0,0,1,9.539,16.16H7.163a1.191,1.191,0,0,1-1.188-1.188v-.594a1.191,1.191,0,0,1,1.188-1.188H9.539a1.191,1.191,0,0,1,1.188,1.188Zm7.126,9.5a1.191,1.191,0,0,1-1.188,1.188H14.29A1.191,1.191,0,0,1,13.1,24.474v-.594a1.191,1.191,0,0,1,1.188-1.188h2.375a1.191,1.191,0,0,1,1.188,1.188v.594Zm0-4.751a1.191,1.191,0,0,1-1.188,1.188H14.29A1.191,1.191,0,0,1,13.1,19.724V19.13a1.191,1.191,0,0,1,1.188-1.188h2.375a1.191,1.191,0,0,1,1.188,1.188v.594Zm0-4.751a1.191,1.191,0,0,1-1.188,1.188H14.29A1.191,1.191,0,0,1,13.1,14.973v-.594a1.191,1.191,0,0,1,1.188-1.188h2.375a1.191,1.191,0,0,1,1.188,1.188v.594Zm7.126,9.5a1.191,1.191,0,0,1-1.188,1.188H21.416a1.191,1.191,0,0,1-1.188-1.188v-.594a1.191,1.191,0,0,1,1.188-1.188h2.375a1.191,1.191,0,0,1,1.188,1.188v.594Zm0-4.751a1.191,1.191,0,0,1-1.188,1.188H21.416a1.191,1.191,0,0,1-1.188-1.188V19.13a1.191,1.191,0,0,1,1.188-1.188h2.375a1.191,1.191,0,0,1,1.188,1.188v.594Zm0-4.751a1.191,1.191,0,0,1-1.188,1.188H21.416a1.191,1.191,0,0,1-1.188-1.188v-.594a1.191,1.191,0,0,1,1.188-1.188h2.375a1.191,1.191,0,0,1,1.188,1.188v.594Zm0-5.345a1.191,1.191,0,0,1-1.188,1.188H7.163A1.191,1.191,0,0,1,5.975,9.628V4.877A1.191,1.191,0,0,1,7.163,3.689H23.791a1.191,1.191,0,0,1,1.188,1.188Z"
                              transform="translate(-3.6 -0.72)" fill="#fff"></path>
                      </svg>
                      Accounting
                    </div>
                  </div>
                  <div class="col-md">
                    <div class="row">
                      <div class="col-md-6">
                        <button class="btn btn-cancel-prime btn-block" routerLink="/admin/adminReportDetails"
                                [queryParams]="{type: 'Account Snapshot'}">Accounting Snapshot
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6" *ngIf="user.role == 'ROLE_ADMIN'">
              <div class="report-box">
                <div class="row">
                  <div class="col-md-auto p-0">
                    <div class="icon-box" style="background-color: #F65454;">
                      <svg xmlns="http://www.w3.org/2000/svg" height="28" viewBox="0 0 12 16">
                        <path id="Icon_awesome-file-invoice" data-name="Icon awesome-file-invoice"
                              d="M9,8H3v2H9Zm2.781-4.719L8.722.219A.749.749,0,0,0,8.191,0H8V4h4V3.809A.748.748,0,0,0,11.781,3.281ZM7,4.25V0H.75A.748.748,0,0,0,0,.75v14.5A.748.748,0,0,0,.75,16h10.5a.748.748,0,0,0,.75-.75V5H7.75A.752.752,0,0,1,7,4.25Zm-5-2A.25.25,0,0,1,2.25,2h2.5A.25.25,0,0,1,5,2.25v.5A.25.25,0,0,1,4.75,3H2.25A.25.25,0,0,1,2,2.75Zm0,2A.25.25,0,0,1,2.25,4h2.5A.25.25,0,0,1,5,4.25v.5A.25.25,0,0,1,4.75,5H2.25A.25.25,0,0,1,2,4.75Zm8,9.5a.25.25,0,0,1-.25.25H7.25A.25.25,0,0,1,7,13.75v-.5A.25.25,0,0,1,7.25,13h2.5a.25.25,0,0,1,.25.25ZM10,7.5v3a.5.5,0,0,1-.5.5h-7a.5.5,0,0,1-.5-.5v-3A.5.5,0,0,1,2.5,7h7A.5.5,0,0,1,10,7.5Z"
                              fill="#fff"></path>
                      </svg>
                      Other Reports
                    </div>
                  </div>
                  <div class="col-md">
                    <div class="row">
                      <div class="col-md-6">
                        <button class="btn btn-cancel-prime btn-block" routerLink="/admin/adminReportDetails"
                                [queryParams]="{type: 'Customer details'}">Customer Details
                        </button>
                      </div>
                      <div class="col-md-6">
                        <button class="btn btn-cancel-prime btn-block" routerLink="/admin/adminReportDetails"
                                [queryParams]="{type: 'Order all details'}">Order All Details
                        </button>
                      </div>
                      <div class="col-md-6">
                        <button class="btn btn-cancel-prime btn-block" routerLink="/admin/adminReportDetails"
                                [queryParams]="{type: 'Products'}">Products
                        </button>
                      </div>
                      <div class="col-md-6">
                        <button class="btn btn-cancel-prime btn-block" routerLink="/admin/adminReportDetails"
                                [queryParams]="{type: 'Account Owner Details'}">Account Owner Details
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6" *ngIf="user.role == 'ROLE_ADMIN'">
              <div class="report-box">
                <div class="row">
                  <div class="col-md-auto p-0">
                    <div class="icon-box" style="background-color: #96D1FE;">
                      <svg xmlns="http://www.w3.org/2000/svg" width="28" viewBox="0 0 16 16">
                        <path id="Icon_material-shopping-cart" data-name="Icon material-shopping-cart" d="M6.3,15.8a1.6,1.6,0,1,0,1.6,1.6A1.6,1.6,0,0,0,6.3,15.8ZM1.5,3V4.6H3.1l2.88,6.072L4.9,12.632a1.547,1.547,0,0,0-.2.768A1.6,1.6,0,0,0,6.3,15h9.6V13.4H6.636a.2.2,0,0,1-.2-.2l.024-.1.72-1.3h5.96a1.592,1.592,0,0,0,1.4-.824L17.4,5.784a.782.782,0,0,0,.1-.384.8.8,0,0,0-.8-.8H4.868L4.116,3ZM14.3,15.8a1.6,1.6,0,1,0,1.6,1.6A1.6,1.6,0,0,0,14.3,15.8Z" transform="translate(-1.5 -3)" fill="#fff"></path>
                      </svg>
                      Audit Logs
                    </div>
                  </div>
                  <div class="col-md">
                    <div class="row">
                      <div class="col-md-6">
                        <button class="btn btn-cancel-prime btn-block" routerLink="/admin/adminReportDetails" [queryParams]="{type: 'Incoming Audit Logs'}">Incoming Audit Logs</button>
                      </div>
                      <div class="col-md-6">
                        <button class="btn btn-cancel-prime btn-block" routerLink="/admin/adminReportDetails" [queryParams]="{type: 'Outgoing Audit Logs'}">Outgoing Audit Logs</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </section>
</form>

